import { Outlet } from "react-router-dom";
import { PageProps } from "../../models/routing.model";

const Participants = (props: PageProps) => {
	return <Outlet />;
};

export default Participants;
